<div
    *ngIf="selectedBlock && selectedBlock.type.key === curatedBlockKey; else placeholder"
    class="agpr-sortTool"
>
    <div class="agpr-sortTool-header">
        <agpr-button
            [style]="buttonTypes.link"
            class="agpr-sortTool-selectMentions"
            [id]="id + (showSelectAll ? '.selectAll' : 'selectNone')"
            (click)="selectMentions()"
            [disabled]="mentions.length < 1"
            [label]="showSelectAll ? 'Monitoring.result.selectAll' : 'Monitoring.result.selectNone'"
            aria-live="polite"
        ></agpr-button>
        <span
            class="agpr-mentionsCount"
            [ngClass]="{'agpr-mentionsCount--disabled': mentions.length < 1}"
        >
            <span class="agpr-mentionsCount-selectedCount">
                {{ selectedMentions.length }}
            </span>
            {{ 'Monitoring.result.of' | localize }}
            <span class="agpr-mentionsCount-total">
                {{ mentions.length }}
            </span>
        </span>
        <span
            class="agpr-moveButtons"
        >
            <agpr-button
                id="briefing.mentions.moveUp"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-arrow-up"
                [disabled]="mentions.length < 1 || selectedMentions.length === mentions.length || selectedMentions.length < 1"
                (click)="moveUp()"
            ></agpr-button>
            <agpr-button
                id="briefing.mentions.moveDown"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-arrow-down"
                [disabled]="mentions.length < 1 || selectedMentions.length === mentions.length || selectedMentions.length < 1"
                (click)="moveDown()"
            ></agpr-button>
        </span>
        <span
            class="agpr-moveButtons"
        >
            <agpr-dropdown
                #moveToDropdown
                [disabled]="mentions.length < 1 || moveToOptions.length < 1 || selectedMentions.length < 1"
                [options]="moveToOptions"
                placeholder="Briefings.sortTool.moveTo.placeholder"
                [ngModel]="selectedMoveToOption"
                (ngModelChange)="moveTo($event.value)"
                ariaLabel="Briefings.sortTool.moveTo.placeholder"
            >
            </agpr-dropdown>
        </span>
    </div>
    <agpr-text-input
        [maxLength]="256"
        class="agpr-sortTool-sectionTitle"
        [(ngModel)]="curatedDisplayElement.title"
        (ngModelChange)="updateSectionTitle()"
        ariaLabel="Briefings.sortTool.editSectionTitle"
    ></agpr-text-input>
    <agpr-scroll-panel>
        <div
            *ngIf="mentions?.length < 1"
            class="agpr-sortTool-noMentionsFound"
        >
            {{ 'Monitoring.result.noMentionsFound' | localize }}
        </div>
        <ul
            [id]="id + '_sortTool_mentionList'"
            class="agpr-sortTool-mentions u-mdBottomMargin agpr-drag-dropzone"
            [dndDropzone]="['mention']"
            dndEffectAllowed="move"
            (dndDrop)="onDropMentions($event)"
            agprListKeyboardNavigation
            [list]="mentions"
        >
            <li
                dndPlaceholderRef
                class="agpr-drag-placeholder"
            ></li>
            <li
                *ngFor="let mention of mentions; trackBy: mentionTrackBy; let i = index;"
                class="agpr-sortTool-mention agpr-contextMenu-parent"
                [dndDraggable]="mention"
                dndType="mention"
                dndEffectAllowed="linkMove"
                (dndStart)="onDragStartMentions(mention, $event)"
                (dndEnd)="cleanupAfterDragCompleted($event)"
            >
                <span class="agpr-sortTool-mentionCheckbox">
                    <agpr-checkbox
                        [id]="'sortTool_mentionCheckbox_' + i"
                        [value]="mention"
                        [hiddenLabel]="mention.headline ? mention.headline : null"
                        [(ngModel)]="selectedMentions"
                        (onChange)="selectedMentionsChange()"
                    ></agpr-checkbox>
                </span>
                <agpr-mention-card
                    [mention]="mention"
                    [canExpand]="false"
                    [badges]="badges"
                    [mentionContent]="selectedBlock?.displayElement?.styles?.mentionContent"
                ></agpr-mention-card>
                <div
                    class="agpr-contextMenu top right"
                >
                    <agpr-button
                        icon="fa-regular fa-duotone fa-pen"
                        [id]="id + '_editMentionButton'"
                        (click)="editMention(mention)"
                        tooltip="PageBuilder.briefings.blockIcon.edit"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                    ></agpr-button>
                    <agpr-button
                        icon="fa-regular fa-duotone fa-trash-can"
                        [id]="id + '_deleteMentionButton'"
                        (click)="deleteMention(mention)"
                        tooltip="PageBuilder.briefings.blockIcon.remove"
                        tooltipPosition="top"
                        [style]="buttonTypes.contextMenu"
                    ></agpr-button>
                </div>
            </li>
        </ul>
    </agpr-scroll-panel>
</div>

<ng-template #placeholder>
    <div class="agpr-sortTool-placeholder">
        <agpr-message
            *ngIf="!selectedBlock"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Briefings.sortTool.notSelected' | localize }}
        </agpr-message>
        <agpr-message
            *ngIf="selectedBlock && selectedBlock.type.key !== curatedBlockKey"
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Briefings.sortTool.notCurated' | localize }}
        </agpr-message>
    </div>
</ng-template>

<div #counter class='agpr-drag-counter'></div>
